import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// NEOIQ-2427: shared by the Peer to Peer and Top-up for Agent success/receipt screens — both had
// byte-for-byte identical html2canvas -> jsPDF -> save logic, differing only in the filename.
export function exportElementToPdf(element: HTMLElement, filename: string): Promise<void> {
    return html2canvas(element).then((canvas) => {
        const doc = new jsPDF('p', 'mm', 'a4');
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 10, 10, 180, 280);
        doc.save(filename);
    });
}
